import { render, staticRenderFns } from "./ClientProfile.vue?vue&type=template&id=d206e3f6&scoped=true&"
import script from "./ClientProfile.vue?vue&type=script&lang=js&"
export * from "./ClientProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d206e3f6",
  null
  
)

export default component.exports